/**
 * Tabs Block Functionality
 * Handles tab switching and read more/less functionality
 */

(function() {
  'use strict';

  // Helper function to decode HTML entities
  function decodeHTML(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  function initTabs() {
    const tabsBlocks = document.querySelectorAll('.tabs-block');
    
    tabsBlocks.forEach(block => {
      // Extract block ID from class name
      const classList = Array.from(block.classList);
      const blockIdClass = classList.find(cls => cls.startsWith('tabs-block--'));
      const blockId = blockIdClass ? blockIdClass.replace('tabs-block--', '') : null;
      
      if (!blockId) return;
      
      const rawBlocksContainer = block.querySelector(`[data-tabs-raw="${blockId}"]`);
      const headersContainer = block.querySelector(`[data-tabs-headers="${blockId}"]`);
      const panelsContainer = block.querySelector(`[data-tabs-panels="${blockId}"]`);
      const emptyMessage = block.querySelector(`[data-tabs-empty="${blockId}"]`);
      
      if (!rawBlocksContainer || !headersContainer || !panelsContainer) return;
      
      // Find all tab block items
      const tabItems = rawBlocksContainer.querySelectorAll('.tab-block-item');
      
      if (tabItems.length === 0) {
        if (emptyMessage) emptyMessage.style.display = 'block';
        return;
      }
      
      if (emptyMessage) emptyMessage.style.display = 'none';
      
      // Clear existing headers and panels
      headersContainer.innerHTML = '';
      panelsContainer.innerHTML = '';
      
      // Create tabs from tab items
      tabItems.forEach((tabItem, index) => {
        const tabId = tabItem.dataset.tabBlockId;
        const tabTitleRaw = tabItem.dataset.tabTitle || `Tab ${index + 1}`;
        const tabTitle = decodeHTML(tabTitleRaw).trim() || `Tab ${index + 1}`;
        const isFirst = index === 0;
        
        // Create header button
        const header = document.createElement('button');
        header.type = 'button';
        header.className = `tabs-block__header${isFirst ? ' tabs-block__header--active' : ''}`;
        header.setAttribute('role', 'tab');
        header.setAttribute('aria-selected', isFirst ? 'true' : 'false');
        header.setAttribute('aria-controls', `tab-panel-${blockId}-${tabId}`);
        header.id = `tab-button-${blockId}-${tabId}`;
        header.dataset.tabId = tabId;
        header.dataset.blockId = blockId;
        header.textContent = tabTitle;
        headersContainer.appendChild(header);
        
        // Create panel
        const panel = document.createElement('div');
        panel.className = `tabs-block__panel${isFirst ? ' tabs-block__panel--active' : ''}`;
        panel.setAttribute('role', 'tabpanel');
        panel.id = `tab-panel-${blockId}-${tabId}`;
        panel.setAttribute('aria-labelledby', `tab-button-${blockId}-${tabId}`);
        panel.dataset.tabId = tabId;
        panel.dataset.blockId = blockId;
        
        // Get content from tab item
        const contentInner = tabItem.querySelector('.tab-block-content');
        if (contentInner) {
          const contentWrapper = document.createElement('div');
          contentWrapper.className = 'tabs-block__content';
          
          const innerDiv = document.createElement('div');
          innerDiv.className = 'tabs-block__content-inner';
          innerDiv.innerHTML = contentInner.innerHTML;
          contentWrapper.appendChild(innerDiv);
          
          // Read More/Less wrapper
          const readMoreWrapper = document.createElement('div');
          readMoreWrapper.className = 'tabs-block__read-more-wrapper';
          
          const fade = document.createElement('div');
          fade.className = 'tabs-block__read-more-fade';
          readMoreWrapper.appendChild(fade);
          
          const readMoreBtn = document.createElement('button');
          readMoreBtn.type = 'button';
          readMoreBtn.className = 'tabs-block__read-more-btn';
          readMoreBtn.dataset.tabContentId = `tab-content-${blockId}-${tabId}`;
          readMoreBtn.setAttribute('aria-expanded', 'false');
          
          const readMoreText = document.createElement('span');
          readMoreText.className = 'tabs-block__read-more-text';
          readMoreText.textContent = 'Read more';
          
          const readLessText = document.createElement('span');
          readLessText.className = 'tabs-block__read-less-text';
          readLessText.style.display = 'none';
          readLessText.textContent = 'Read less';
          
          readMoreBtn.appendChild(readMoreText);
          readMoreBtn.appendChild(readLessText);
          readMoreWrapper.appendChild(readMoreBtn);
          
          contentWrapper.appendChild(readMoreWrapper);
          panel.appendChild(contentWrapper);
        }
        
        panelsContainer.appendChild(panel);
      });
      
      // Set up tab switching - SIMPLE VERSION
      const headers = headersContainer.querySelectorAll('.tabs-block__header');
      const panels = panelsContainer.querySelectorAll('.tabs-block__panel');
      
      // Set container height to prevent jerking - measure only the active panel initially
      const setContainerHeight = () => {
        const activePanel = panelsContainer.querySelector('.tabs-block__panel--active');
        if (activePanel) {
          // Wait for panel to be fully rendered
          requestAnimationFrame(() => {
            const height = activePanel.scrollHeight || activePanel.offsetHeight || 0;
            // Only set reasonable heights
            if (height > 50 && height < 3000) {
              panelsContainer.style.minHeight = height + 'px';
            }
          });
        }
      };
      
      // Set height after content loads
      setTimeout(setContainerHeight, 200);
      
      // Update height when tab changes - more accurate measurement
      const updateHeight = (panel) => {
        if (panel) {
          // Wait a bit for content to render
          setTimeout(() => {
            const height = panel.scrollHeight || panel.offsetHeight || 0;
            const currentHeight = parseInt(panelsContainer.style.minHeight) || 0;
            // Only update if height is reasonable and different
            if (height > 50 && height < 3000) {
              // Allow small adjustments but prevent huge jumps
              if (Math.abs(height - currentHeight) > 20) {
                if (height > currentHeight) {
                  // Increase smoothly
                  panelsContainer.style.minHeight = height + 'px';
                } else if (height < currentHeight - 50) {
                  // Only decrease if significantly smaller (to prevent jerking)
                  panelsContainer.style.minHeight = height + 'px';
                }
              }
            }
          }, 100);
        }
      };
      
      headers.forEach(header => {
        header.addEventListener('click', () => {
          // Don't do anything if already active
          if (header.classList.contains('tabs-block__header--active')) {
            return;
          }
          
          const tabId = header.dataset.tabId;
          
          // Remove active from all
          headers.forEach(h => {
            h.classList.remove('tabs-block__header--active');
            h.setAttribute('aria-selected', 'false');
          });
          
          panels.forEach(p => {
            p.classList.remove('tabs-block__panel--active');
          });
          
          // Add active to clicked
          header.classList.add('tabs-block__header--active');
          header.setAttribute('aria-selected', 'true');
          
          const targetPanel = panelsContainer.querySelector(`[data-tab-id="${tabId}"]`);
          if (targetPanel) {
            targetPanel.classList.add('tabs-block__panel--active');
            
            // Scroll to top of the tabs block (headers) smoothly so user can see the tab
            requestAnimationFrame(() => {
              // Scroll to the headers container so user sees which tab is active
              headersContainer.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start',
                inline: 'nearest'
              });
            });
            
            // Update container height for new panel
            updateHeight(targetPanel);
            initReadMore(targetPanel);
          }
        });
      });
      
      // Initialize read more for the first active tab
      const activePanel = panelsContainer.querySelector('.tabs-block__panel--active');
      if (activePanel) {
        initReadMore(activePanel);
      }
    });
  }

  function initReadMore(panel) {
    const contentInner = panel.querySelector('.tabs-block__content-inner');
    const readMoreBtn = panel.querySelector('.tabs-block__read-more-btn');
    const readMoreWrapper = panel.querySelector('.tabs-block__read-more-wrapper');
    
    if (!contentInner || !readMoreBtn || !readMoreWrapper) return;
    
    // Reset state
    contentInner.classList.remove('is-collapsed');
    readMoreWrapper.classList.remove('has-fade');
    readMoreBtn.setAttribute('aria-expanded', 'false');
    
    // Check if content needs read more
    setTimeout(() => {
      const computedStyle = window.getComputedStyle(contentInner);
      const lineHeight = parseFloat(computedStyle.lineHeight) || parseFloat(computedStyle.fontSize) * 1.6;
      const maxHeight = lineHeight * 3;
      const contentHeight = contentInner.scrollHeight;
      
      if (contentHeight > maxHeight) {
        contentInner.classList.add('is-collapsed');
        contentInner.style.maxHeight = maxHeight + 'px';
        readMoreWrapper.classList.add('has-fade');
        readMoreBtn.style.display = 'inline-flex';
        
        readMoreBtn.onclick = function() {
          const isExpanded = this.getAttribute('aria-expanded') === 'true';
          
          if (isExpanded) {
            contentInner.classList.add('is-collapsed');
            contentInner.style.maxHeight = maxHeight + 'px';
            readMoreWrapper.classList.add('has-fade');
            this.setAttribute('aria-expanded', 'false');
            // Scroll to top of content
            contentInner.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            contentInner.classList.remove('is-collapsed');
            contentInner.style.maxHeight = 'none';
            readMoreWrapper.classList.remove('has-fade');
            this.setAttribute('aria-expanded', 'true');
            // Scroll to top of content so user can read from the beginning
            requestAnimationFrame(() => {
              contentInner.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          }
        };
      } else {
        readMoreBtn.style.display = 'none';
        readMoreWrapper.classList.remove('has-fade');
      }
    }, 50);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }

  // Reinitialize when theme editor updates
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initTabs);
    document.addEventListener('shopify:block:select', initTabs);
  }
})();
